import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { updateDefaultRoleConfiguration } from '@/configurations/actions';
import { configurationCodes } from '@/configurations/constants';
import DropdownItem from '@/components/DropdownItem';
import { roleManagementAccessControl } from '../helper';
import { showRoleActions } from '../roleactions/actions';
import { showSaveRole } from '../actions';

const RoleTools = ({
  allowConfigurations,
  allowCreate,
  allowRoleActionsEdit,
  category,
  changeDefaultRole,
  duplicateRole,
  role,
  roleActions,
  roleActionsReadStatus,
  showActions,
}) => (
  <>
    {allowCreate && (
    <DropdownItem icon="clone" textId="actions.duplicate" onClick={() => duplicateRole(role.code, category)} />
    )}
    {allowConfigurations && (
    <DropdownItem icon="cog" textId="actions.default" onClick={() => changeDefaultRole(category, role)} />
    )}
    {allowRoleActionsEdit && (
    <DropdownItem
      icon="external"
      textId="actions.role-actions"
      onClick={() => showActions(role.code, category, roleActions, roleActionsReadStatus)}
    />
    )}
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions } },
  configurations: { configurations },
}, { role }) => {
  const defaultRole = findResult(configurations, 'all', configurationCodes.DEFAULT_ROLE) || {
    value: { value: '' },
  };

  return (
    {
      ...roleManagementAccessControl({ permissions }, role),
      allowConfigurations: permissions.configurations.update
          && role.code !== defaultRole.value.value && role.assignable,
      roleActions: role.roleActions.items,
      roleActionsReadStatus: role.roleActions.readStatus,
    }
  );
};

const mapDispatchToProps = {
  duplicateRole: showSaveRole,
  changeDefaultRole: updateDefaultRoleConfiguration,
  showActions: showRoleActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleTools);
